import TableHeader from './TableHeader'

export default TableHeader



// WEBPACK FOOTER //
// ./src/legacy/containers/Tables/components/TableHeader/index.js